module.exports = __webpack_public_path__ + "static/media/Video Gamer.3268a57b.jpg";